import { Platform, StyleSheet, View } from "react-native";
import { ShieldCheck } from "lucide-react-native";
import { useRouter } from "expo-router";
import { useTranslation } from "react-i18next";
import { colors, spacing } from "@tabbio/tokens";
import { Text } from "../common/AppText";
import { NativeButton } from "../common/NativeButton";
import { useTheme } from "../../hooks/useTheme";
import { endAppImpersonation, useAppAuthState } from "../../lib/app-auth";

export function ImpersonationBanner() {
  const router = useRouter();
  const { theme } = useTheme();
  const { t } = useTranslation("common");
  const state = useAppAuthState();
  const impersonation = state.impersonation;
  if (!impersonation || !state.user) return null;

  const exit = async () => {
    await endAppImpersonation();
    router.replace("/");
  };

  return (
    <View
      accessibilityRole="summary"
      style={[
        styles.banner,
        {
          paddingTop: Platform.OS === "web" ? spacing[2] : spacing[5],
          backgroundColor: theme.surfaceElevated,
          borderColor: theme.border,
        },
      ]}
    >
      <ShieldCheck size={18} color={colors.warning} strokeWidth={1.9} />
      <View style={styles.copy}>
        <Text numberOfLines={1} style={[styles.title, { color: theme.text }]}>
          {t("supportSession.bannerTitle", { name: state.user.name })}
        </Text>
        <Text
          numberOfLines={1}
          style={[styles.detail, { color: theme.textSecondary }]}
        >
          {t("supportSession.bannerDescription")}
        </Text>
      </View>
      <NativeButton
        title={t("supportSession.exit")}
        onPress={() => void exit()}
        variant="outline"
        size="xs"
      />
    </View>
  );
}

const styles = StyleSheet.create({
  banner: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    minHeight: 46,
    flexDirection: "row",
    alignItems: "center",
    gap: spacing[2],
    paddingHorizontal: spacing[3],
    paddingBottom: spacing[2],
    borderBottomWidth: StyleSheet.hairlineWidth,
  },
  copy: { flex: 1, minWidth: 0 },
  title: { fontSize: 12, fontWeight: "700" },
  detail: { marginTop: 1, fontSize: 10 },
});
